import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import classNames from 'classnames'

class LoadingButtonComponent extends Component {
  render() {
    const color = this.props.color === undefined ? 'primary' : this.props.color

    // const isDisabled =
    // 	color === 'primary' ? this.props.classes[`${color}Disabled`] : undefined

    const {
      type,
      classes,
      working,
      disabled,
      buttonclicked,
      title,
      ...other
    } = this.props
    return (
      <div
        className={classNames(
          classes.wrapper,
          {
            [classes.wrapperFullWidth]: other.fullWidth
          },
          this.props.className
        )}
      >
        <Button
          type={type || 'button'}
          variant="contained"
          color={color}
          disabled={working || disabled}
          classes={{ disabled: this.props.classes[`${color}Disabled`] }}
          onClick={buttonclicked}
          className={classNames({
            [this.props.classes.buttonSizeSmall]: this.props.size === 'small'
          })}
          {...other}
        >
          {this.props.children}
        </Button>
        {working && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(LoadingButtonComponent)
